import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import icon1 from "../assets/images/location.svg";
import icon2 from "../assets/images/phone.svg";
import icon3 from "../assets/images/mail.svg";
import twitter from "../assets/images/twitter.svg"
import facebook from "../assets/images/facebook.svg"
import instagram from "../assets/images/instagram.svg"
import linkdin from "../assets/images/linkdin.svg"


type LinkType = {
  name: string;
  path: string;
  href: string;
  target?: string;
  active?: boolean;
};

type Social = {
  icon: string
  path: string
}

const links: LinkType[] = [
  {
    name: "Home",
    path: "/",
    href: "#",
    active: false,
  },
  {
    name: "About Me",
    path: "/about-us",
    href: "#",
    active: false,
  },
  // {
  //   name: "Experience",
  //   path: "/experience",
  //   href: "#",
  //   active: false,
  // },
  {
    name: "Blog",
    path: "/blogs",
    href: "#",
    active: false,
  },
  {
    name: "Contact",
    path: "/contact",
    href: "#",
    active: false,
  },
  {
    name: "FAQ",
    path: "/faq",
    href: "#",
    active:false
  }
];

const socials: Social[] = [
  {
    icon: twitter,
    path: "https://x.com/JohnBostjancic",
  },
  {
    icon: facebook,
    path: "https://www.facebook.com/john.bostjancic.5",
  },
  {
    icon: linkdin,
    path: "https://www.linkedin.com/in/john-bostjancic-6b58243/",
  },
  {
    icon: instagram,
    path: "https://www.instagram.com/john.bostjancic/",
  },
];

const Footer = () => {

  const [navLinks, setNavLinks] = useState<LinkType[]>(links);
  const location = useLocation();

  const setActiveNav = (pageName: string) => {
    const newNavLinks = links.map((item) => {
      item.active = false;
      if (item.name === pageName) {
        item.active = true;
      }
      return item;
    });
    setNavLinks(newNavLinks);
  };

  useEffect(() => {
    links.forEach((item) => {
      if (item.path === location.pathname) {
        setActiveNav(item.name);
      }
    });

    if (window.location.pathname === "/" && window.location.hash === "") {
      setActiveNav("Home");
    }
  }, [location]);

  return (
    <>
      <div className="bg-[#E7E9FF] relative z-10">
        <div className="max-w-screen-2xl mx-auto px-5 sm:px-20 py-8 flex flex-col lg:flex-row gap-4 lg:gap-0 justify-between">
          <div className="flex  gap-4">
            <div className="py-3 px-4 bg-primary rounded-xl self-start">
              <img src={icon1} alt="" className="size-8" />
            </div>
            <div className="">
              <p className="montserrat-semibold text-secondary">Address</p>
              <p className="montserrat-regular text-secondary">Carlsbad, CA</p>
            </div>
          </div>
          <div className="border-l-2 border-secondary "></div>
          <div className="flex gap-4">
            <div className="py-3 px-4 bg-primary rounded-xl self-start">
              <img src={icon2} alt="" className="size-8" />
            </div>
            <div className="">
              <p className="montserrat-semibold text-secondary">Phone</p>
              <a
                href="tel:+19087237194"
                className="montserrat-regular text-secondary"
              >
                +1 908-723-7194
              </a>
            </div>
          </div>
          <div className="border-l-2 border-secondary"></div>
          <div className="flex gap-4">
            <div className="py-3 px-4 bg-primary rounded-xl self-start">
              <img src={icon3} alt="" className="size-8" />
            </div>
            <div className="">
              <p className="montserrat-semibold text-secondary">
                Help & Supoort
              </p>
              <a
                href="mailto:john.bostjancic@gmail.com"
                className="montserrat-regular text-secondary"
              >
                john.bostjancic@gmail.com
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-primary">
        <div className="max-w-screen-2xl mx-auto px-5 md:px-10 lg:px-16 xl:px-20 pt-10 lg:pt-24">
          <div className="w-full flex justify-end mb-4">        
              <a href="http://admin.techqilla.com/" target="_blank" rel="noreferrer">
                <button
                  className={`rounded-full py-2 px-6 bg-[#E9FF7A] hover:-translate-y-1 transition-all duration-300 relative z-50 text-black`}
                >
                  Admin Login
                </button>
              </a>
          </div>
          <nav className="flex flex-col lg:flex-row gap-4 justify-between items-center pb-10 border-b-2 border-[#054999]">
            <div className="flex justify-between">
              <Link to="/" className="">
                <h2 className="montserrat-subrayada-regular text-white text-2xl">
                  johnbostjancic
                </h2>
              </Link>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-0 md:space-x-10 list-none montserrat-medium items-center">
              {navLinks.map((link, index) => (
                <div className="relative z-10 group text-center" key={index}>
                  <Link
                    to={link.path}
                    key={link.name}
                    onClick={() => setActiveNav(link.name)}
                    className="text-base text-white list-none "
                  >
                    {link.name}
                  </Link>
                  <div
                    className={`absolute top-6 left-4 sm:left-0 h-1 rounded-full bg-white transition-all duration-500 ease-in-out ${
                      link.active ? "w-[60%]" : "w-0 group-hover:w-[60%] "
                    }`}
                  ></div>
                </div>
              ))}
            </div>
            <div className="flex gap-4">
              {socials.map((item, index) => (
                <a
                  href={item.path}
                  target="_blanck"
                  className="size-6 p-1 flex justify-center items-center hover:scale-150 transition-all duration-300 cursor-pointer"
                  key={index}
                >
                  <img src={item.icon} alt="" className="fill-secondary" />
                </a>
              ))}
            </div>
          </nav>

          <div className="py-5 flex flex-col sm:flex-row gap-4 justify-between">
            <p className="montserrat-medium text-white text-sm">
              © 2024 JohnBostjancic. All right reserved.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
